import { useLang } from "@/App";
import { copy } from "@/i18n";

const Marquee = () => {
    const { lang } = useLang();
    const items = copy[lang].marquee;
    const row = [...items, ...items, ...items, ...items];

    return (
        <div data-testid="marquee-section" className="relative border-y border-white/10 bg-coal/60 py-5 overflow-hidden">
            <div className="marquee-track">
                {[0, 1].map((half) => (
                    <div key={half} className="flex shrink-0 items-center">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="font-display uppercase tracking-tight text-xl sm:text-2xl text-neutral-300 px-6">
                                    {item}
                                </span>
                                <span className="w-2 h-2 rotate-45 bg-crimson shrink-0" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
